import React, { useEffect, useState } from "react";
import classes from "./AssessmentAndSubmission.module.css";
import { useDispatch, useSelector } from "react-redux";
import SingleLessonAssessment from "./Assessments/SingleLessonAssessment";
import ScrollLTR from "../../../UI/ScrollLTR";
import { LESSONTYPESENUM } from "../../../../cms/Editor/utils";
import DynamicPopup from "../../../UI/Popups/DynamicPopup/DynamicPopup";
import { assessmentsApi } from "../../../../../utils";
import { ActivityTypeEnum } from "../../../models/ActivityTypeEnum";
import { SourceTypeEnumText } from "../../../models/SourceTypeEnum";
import LessonAssesments from "./Assessments/LessonAssesments";
import { throwApiError } from "../../../store/error-handling-actions";

const AssessmentAndSubmission = ({
    lessonParticipant,
    name,
    selectedAssessmentId,
    id,
    openProject,
    ProjectsComm,
    studyGroupId,
    allUserIds,
    teacherMode,
    saveProjectCallback,
    shareBtn,
    onlyView,
    hundleShowLessonQuestion,
    materialContentType,
    setShowReflection }) => {

    const texts = useSelector(state => state.translate.texts);
    const user = useSelector((state) => state.auth.user);
    const [popupAssessmentLesson, setPopupAssessmentLesson] = useState()
    const [scoreOptions, setScoreOptions] = useState([])
    const [assessmentData, setAssessmentData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const getScoreOptionsFromApi = async () => {
            const res = await fetch(window.config.dynamicIndicatorTeacher);
            const resJson = await res.json();
            setScoreOptions(resJson.scoreOptions);
        }
        getScoreOptionsFromApi()
    }, [])

    useEffect(() => {
        const getAssessmentsFromApi = async () => {
            const assessmentFilterRange = {
                toCId: id,
                sourceType: SourceTypeEnumText.IDE,
                includeSubmissions: true,
                includeAssessmentAggregation: materialContentType === LESSONTYPESENUM.SLC,
                studyGroupId,
            }
            assessmentsApi.assessmentsFilterRangePost({ assessmentFilterRange }, async (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "assessmentsFilterRangePost " + error.message, level: 1, component: "AssessmentAndSubmission", line: 54 }))
                }
                else {
                    if (selectedAssessmentId) {
                        setAssessmentData(resdata.assessments?.find(a => a.id == selectedAssessmentId));
                    }
                    else {
                        setAssessmentData({
                            assessmentAggregation: resdata.assessmentAggregation,
                            finalAssessment: resdata.assessments?.find(a => ActivityTypeEnum[a.activityType] === ActivityTypeEnum.Final),
                            learningAssessments: resdata.assessments?.filter(a => ActivityTypeEnum[a.activityType] === ActivityTypeEnum.Learning)
                        })
                    }
                }
            })
        }
        if (id) {
            getAssessmentsFromApi();
        }
    }, [id, materialContentType])

    const changeSubmission = (key, value) => {
        if (popupAssessmentLesson.id === assessmentData.finalAssessment?.id) {
            setAssessmentData({
                ...assessmentData,
                finalAssessment: { ...assessmentData.finalAssessment, submission: { ...assessmentData.finalAssessment.submission, [key]: value } }
            })
            setPopupAssessmentLesson({ ...assessmentData.finalAssessment, submission: { ...assessmentData.finalAssessment.submission, [key]: value } })
        }
        else {
            let learningAssessments = [...assessmentData.learningAssessments];
            const currentAssessmentIndex = learningAssessments.findIndex(a => a.id === popupAssessmentLesson.id);
            learningAssessments[currentAssessmentIndex] = { ...learningAssessments[currentAssessmentIndex], submission: { ...learningAssessments[currentAssessmentIndex].submission, [key]: value } }
            setAssessmentData({ ...assessmentData, learningAssessments })
            setPopupAssessmentLesson(learningAssessments[currentAssessmentIndex])
        }
    }

    return (
        <ScrollLTR dropStyle={{ width: "100%", height: "100%" }} downDropStyle={{ paddingInlineStart: "15px", width: "100%", height: "100%" }}>
            {selectedAssessmentId ?
                <SingleLessonAssessment
                    assessment={assessmentData}
                    setAssesmentStatus={newStatus => setAssessmentData({ ...assessmentData, submission: { ...assessmentData.submission, submissionStatus: newStatus } })}
                    setSubmissionProject={newProject => setAssessmentData({ ...assessmentData, submission: { ...assessmentData.submission, project: newProject } })}
                    updateAttachments={newAttachments => setAssessmentData({ ...assessmentData, submission: { ...assessmentData.submission, contentData: newAttachments } })}
                    openProject={openProject}
                    ProjectsComm={ProjectsComm}
                    studyGroupId={studyGroupId}
                    teacherMode={teacherMode}
                    saveProjectCallback={saveProjectCallback}
                    shareBtn={shareBtn}
                    onlyView={onlyView}
                    nameLesson={name}
                    lessonParticipant={lessonParticipant}
                    setShowReflection={setShowReflection}
                    setPopupAssessmentLesson={setPopupAssessmentLesson}
                    lessonId={id}
                    isDisabled={true} />
                :
                <LessonAssesments
                    {...assessmentData}
                    scoreOptions={scoreOptions}
                    hundleShowLessonQuestion={hundleShowLessonQuestion}
                    setPopupAssessmentLesson={setPopupAssessmentLesson} />
            }

            {
                popupAssessmentLesson &&
                <DynamicPopup closePopup={() => setPopupAssessmentLesson(false)} title={(ActivityTypeEnum[popupAssessmentLesson.activityType] === ActivityTypeEnum.Learning ? texts.learningAssessment : texts.assessment) + ": " + popupAssessmentLesson.name} myWidth={window.innerWidth > 1040 ? "1040px" : "80%"} minHeight={window.innerHeight > 682 ? "682px" : "95%"} dropClass={classes.SubmissionTasksPopup} >
                    <div className={classes.SubmissionTasks}>
                        <SingleLessonAssessment
                            assessment={popupAssessmentLesson}
                            setAssesmentStatus={newStatus => changeSubmission('submissionStatus', newStatus)}
                            setSubmissionProject={newProject => changeSubmission('project', newProject)}
                            updateAttachments={newAttachments => changeSubmission('contentData', newAttachments)}
                            openProject={openProject}
                            ProjectsComm={ProjectsComm}
                            studyGroupId={studyGroupId}
                            teacherMode={teacherMode}
                            saveProjectCallback={saveProjectCallback}
                            shareBtn={shareBtn}
                            onlyView={onlyView}
                            nameLesson={name}
                            lessonParticipant={lessonParticipant}
                            setShowReflection={setShowReflection}
                            setPopupAssessmentLesson={setPopupAssessmentLesson}
                            isDisabled={false}
                            lessonId={id}
                        />
                    </div>
                </DynamicPopup>
            }

        </ScrollLTR >
    )
}

export default AssessmentAndSubmission;
